import React from "react";
import {
    Container,
    TextField,
    Typography,
    Box,
    FormControl,
    Button,
    Tab,
    Tabs,
    Autocomplete,
} from "@mui/material";
import { useSelector } from "react-redux";
import './EstimateView.css';
import moment from 'moment';
import { sortByString } from '../../utils/sortByString';
import PointListTable from "./PointListTable";
import BotmarkEstimateDataView from "./BotmarkEstimateDataView";
import BotmarkCompanyAddress from '../../components/BotmarkCompanyAddress';
import { useCompanyMessages } from '../../hooks/useMessages';
import { useAdminCompany } from '../../context/AdminCompanyContext';
import { useSAConfig } from '../../hooks/useSAConfig';
import { EMPTY_GUID, NA_CUSTOMER_OPTION, customerAutocompleteOptions, isCustomerOptionEqual } from '../../query/queryConfig';
import { useSetCustomerForFile } from '../../hooks/useFiles';
import TabPanel from '../../components/TabPanel';

function BotmarkEstimateView({ botmarkEstimateObj, handleCloseBotmarkEstimate, managePlans, dispatchSettings }) {
    /// auto generation of botmark invoice for processors
    const { companyData: adminCompanyData } = useAdminCompany();
    const { data: saConfigData = [] } = useSAConfig();
    const file = useSelector((state) => state.FileReducer.file.info);
    const fileReport = useSelector((state) => state.FileReducer.file);
    const userData = useSelector((state) => state.UserReducer.user);
    const company = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const setCustomerForFile = useSetCustomerForFile();

    const [invoiceOption, setInvoiceOption] = React.useState([]);
    const [botmarkTotal, setBotmarkTotal] = React.useState(0);
    const [pointTypeTotal, setPointTypeTotal] = React.useState(0);
    const [specialPointTypeTotal, setSpecialPointTypeTotal] = React.useState(0);
    const [customer, setCustomer] = React.useState(EMPTY_GUID);

    let data = [];
    data = JSON?.parse(botmarkEstimateObj?.botmarkInvoiceValues);

    const [baseServiceFee, setBaseServiceFee] = React.useState(0);

    function initValues(){
        for (let i = 0; i < saConfigData?.length; i++){
            if (saConfigData[i]?.configName == 'Base Service Fee'){
                setBaseServiceFee(saConfigData[i]?.configValue);
            }
        }
    }

    let selectedCompanyValues = {};
    if(managePlans == true){
        selectedCompanyValues = adminCompanyData;
    } else{
        selectedCompanyValues = company;
    };

    let pointList = "";
    if(botmarkEstimateObj?.pointList != ""){
        pointList = JSON.parse(botmarkEstimateObj?.pointList);
    }
    let finalTotal = 0;

    //
    /// For File name selection in invoice ///
    //
    function getLastItem(thePath) {
        if (thePath == null || thePath == "") return "";
        var index = thePath.lastIndexOf('/') + 1;
        return thePath.substring(index);
    }

    let pointTotal = 0;
    let tempTotal = 0;
    let specialPointTotal = 0;
    
    function pointCounter(){
        for (let i = 0; i < pointList?.length; i++) {
            if (pointList[i].TypeEnum == 1 || pointList[i].TypeEnum == 2 || pointList[i].TypeEnum == 3 ){
                pointTotal += pointList[i].Quantity;
            }
            if (pointList[i].TypeEnum == 4){
                if (pointList[i].ShouldCharge == true && pointList[i].Enabled == true){
                    specialPointTotal += pointList[i].Quantity;
                }
            }
        }
        setPointTypeTotal(pointTotal);
        setSpecialPointTypeTotal(specialPointTotal);
    }

  /// This sets the dropdown to select a customer for a plan in invoicing ///
    const { data: allCompanyMessages = [] } = useCompanyMessages({
        companyId: selectedCompanyValues?.id,
        enabled: Boolean(selectedCompanyValues?.id),
        pauseRefetch: true,
    });

    const [ selectedCustomer, setSelectedCustomer] = React.useState(NA_CUSTOMER_OPTION);

    let allCustomersArray = sortByString(allCompanyMessages ?? [], 'companyContact');

    const defaultProps = {
        options: customerAutocompleteOptions(allCustomersArray),
        getOptionLabel: (option) => option.companyContact ?? '',
        isOptionEqualToValue: isCustomerOptionEqual,
    };

    /// Handle assignment of a customer to a plan ///
    const handleChange = (event) => {
        setCustomer(event.target.value);
    };
    
    function setCustomertoFile(value){
        if(value == null){
            setCustomerForFile.mutate({ file: file.id, customer: EMPTY_GUID });
            setCustomer(selectedCompanyValues.id);
        } else {
            setCustomerForFile.mutate({ file: file.id, customer: value.userCompanyId });
            setCustomer(value.userCompanyId);
        }
    };
    
    function initCustomer(){
        const customerList = allCompanyMessages;
        setCustomer(botmarkEstimateObj.customerId);
        if (botmarkEstimateObj.customerId != EMPTY_GUID){
            for (let i = 0; i < customerList.length; i++){
                if (botmarkEstimateObj.customerId == customerList[i].userCompanyId){
                    setSelectedCustomer(customerList[i]);
                    setCustomer(customerList[i].userCompanyId);
                }
            }
        } else {
            setCustomer(selectedCompanyValues?.id);
        }
    };

    const [results, setResults] = React.useState(fileReport.file);
    const [value, setValue] = React.useState(0);
    const [summary, setSummary] = React.useState(fileReport.summary);

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    React.useEffect(() => {
        setResults(fileReport.file);
        setSummary(fileReport.summary);
    }, [fileReport.file, fileReport.summary]);
    
    React.useEffect(() => {
        pointCounter();
        initValues();
    }, [company, adminCompanyData, file, botmarkEstimateObj?.id, botmarkEstimateObj?.pointList]);

    React.useEffect(()=>{
        initCustomer();
    },[]);

    return (
        <Container style={{ backgroundColor: 'lightgray', maxWidth: '100vw', position: 'fixed', height: '100%' }}>
            <Container className='estimatePage' maxWidth="sm" style={{ padding: 20, width: '100vw', display: 'flex', flexDirection: 'column', overflowY: 'scroll', height:'inherit' }}>
                <Box sx={{ width: '100%' }}>
                    <Tabs value={value} onChange={handleTabChange} centered style={{borderBottom:'2px solid black', paddingBottom:'10px'}}>
                        <Tab label="Estimate Review"/>
                        {botmarkEstimateObj.isProcessed == 1 &&
                            <Tab label="Validation & Summary"/>
                        }
                    </Tabs>
                    <TabPanel value={value} index={0} style={{}}>
                        <Container>
                            <Typography variant="h4" align="right">
                                Estimate Review
                            </Typography>
                            <p style={{ display: "flex", justifyContent: 'right', width: "100%" }}>
                                <span style={{ marginRight: 50 }}>Date: {moment().format("MM/DD/YYYY")}</span>
                                <span># {data?.estimateNumber}</span>
                            </p>
                            <div style={{ display: 'flex' }}>
                                <div style={{ flex: 1, margin: 10 }}>
                                    <div style={{ flex: 1, margin: 2 }}>
                                        <BotmarkCompanyAddress heading="From Botmark:" />
                                    </div>
                                    <div style={{ flex: 1, margin: 10 }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: 10 }}>
                                            <span style={{ display: "flex", justifyContent: 'left' }}><b>To Processor:</b></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Company: {selectedCompanyValues.name}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{selectedCompanyValues?.email}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Phone: {selectedCompanyValues?.phoneNumber}</span></span>
                                            <br />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ flex: 1, margin: 10 }}>
                                    { selectedCompanyValues.processExternal == true &&
                                        <Box>
                                            {botmarkEstimateObj.isProcessed == 1 &&
                                                <form style={{display:'flex', flexDirection:'column'}}>
                                                    {/* <h4>Customer Select</h4> */}
                                                    {/* <p>Select customer to set any applicable pricing options and to generate customer estimate upon acceptance of this estimate.</p> */}
                                                    <FormControl fullWidth>
                                                        <Autocomplete
                                                            disablePortal
                                                            value={selectedCustomer}
                                                            {...defaultProps}
                                                            renderInput={(params) =>
                                                                <TextField
                                                                    {...params}
                                                                    label="Customer Select"
                                                                />}
                                                            onChange={(event,newValue) => {
                                                                if(newValue == null){setSelectedCustomer(NA_CUSTOMER_OPTION)}else{setSelectedCustomer(newValue)} setCustomertoFile(newValue)}}
                                                        />
                                                    </FormControl>
                                                </form>
                                            }
                                            { selectedCustomer?.userCompanyId != EMPTY_GUID &&
                                                <div>
                                                    <br/>
                                                    <span style={{ display: "flex", justifyContent: 'left' }}><b>For Customer:</b></span>
                                                    <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Company: {selectedCustomer?.companyContact}</span></span>
                                                    <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Email: {selectedCustomer?.companyEmail}</span></span>
                                                    <br></br>
                                                    { selectedCustomer?.customerRequestEstimate == true &&
                                                        <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span><b><u>*** Customer Requests Estimates ***</u></b></span></span>
                                                    }
                                                </div>
                                            }
                                        </Box>
                                    }
                                </div>
                                <PointListTable pointList={pointList} name={botmarkEstimateObj.name} id={botmarkEstimateObj.id} pointTypeTotal={pointTypeTotal}/>
                            </div>
                        <br />
                        <Typography variant="body1">
                            <b>Estimate</b>
                        </Typography>
                        <BotmarkEstimateDataView
                            key={botmarkEstimateObj?.id}
                            dispatchSettings={dispatchSettings}
                            baseServiceFee={baseServiceFee}
                            customer={customer}
                            handleCloseBotmarkEstimate={handleCloseBotmarkEstimate}
                            userData={userData}
                            finalTotal={finalTotal}
                            specialPointTypeTotal={specialPointTypeTotal}
                            pointTypeTotal={pointTypeTotal}
                            botmarkEstimateObj={botmarkEstimateObj}
                            invoiceOption={invoiceOption}
                            botmarkTotal={botmarkTotal}
                            company={company}
                            companyData={adminCompanyData}
                            selectedCustomer={selectedCustomer}
                            managePlans={managePlans}
                        />
                        <br />
                    </Container>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Box m={2} sx={{  display: 'flex', flexDirection:'row', justifyContent: 'center',height: '100%', minHeight: '300px'}}>
                        <div style={{flex:2, margin: 20, overflowX:'scroll'}}>
                            <h4 style={{textAlign:'left'}}>Validation:</h4>
                            <pre style={{textAlign:'left'}}>
                                {results}
                            </pre>
                        </div>
                        <div style={{flex:1, margin:20}}>
                            <h4 style={{textAlign:'left'}}>Summary:</h4>
                                    <pre style={{textAlign:'left'}}>
                                        {summary}
                                    </pre>
                            </div>
                        </Box> 
                    </TabPanel>
                </Box>
            </Container>
        </Container>
    )
};

export default BotmarkEstimateView;